import Product = FBInstant.Product;
import { ShopCatalog, ShopProductIDs } from '../../../../Config/Shop';
import Core from '../../../../Core/Core';
import { createOutlineText, scaleToFit } from '../../../../Utils/Utils';
import { TextButton } from '../../../Shared/Buttons/TextButton';
import { UIButton } from '../../../Shared/Buttons/UIButton';
import { ShopProduct } from './ShopProduct';

export class SmallProduct extends ShopProduct {
    constructor(product: Product) {
        super(product);
        const bg = (this.bg = new PIXI.Sprite(PIXI.utils.TextureCache['commonui/shop-bg-small']));
        bg.anchor.set(0.5);

        const itemWidth = bg.width * 0.3;
        const itemHeight = bg.height / 6;

        const title = createOutlineText(
            Core.local.getText('coins'),
            new PIXI.Rectangle(0, 0, bg.width, bg.height * 0.25),
            'Baloo'
        );
        title.anchor.set(0.5, 0);
        // title.x = -bg.width * 0.47;
        title.y = -bg.height * 0.47;

        const buyButton = new TextButton({
            btnText: product.price,
            width: bg.width,
            height: bg.height * 0.3,
        });
        buyButton.y = buyButton.height * 0.9;
        buyButton.on(UIButton.events.Trigger, this.buy.bind(this));

        const { val } = ShopCatalog[product.productID as ShopProductIDs].items[0];
        //@ts-ignore
        const key = Math.min(Object.values(ShopProductIDs).indexOf(product.productID) - 2, 4);
        const coinIcon = new PIXI.Sprite(PIXI.utils.TextureCache[`commonui/shop-coins-${key}`]);
        coinIcon.anchor.set(0.5);
        const amount = createOutlineText(
            `${val}`,
            new PIXI.Rectangle(0, 0, bg.width, bg.height * 0.01),
            'Baloo'
        );
        amount.anchor.set(0.5);
        coinIcon.x = -bg.width * 0.3;
        amount.y = coinIcon.y = -bg.height * 0.04;
        amount.scale.set(
            Math.min(scaleToFit(amount.width, amount.height, itemWidth, itemHeight), 1)
        );
        //@ts-ignore
        this.addChild(bg, buyButton, amount, coinIcon, title);
    }
}
